/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const paginatedValidationWorkflowListListResultsItemSlugRegExp =
    new RegExp('[-a-zA-Z0-9_]+');
export const paginatedValidationWorkflowListListResultsItemNameMax = 256;

export const PaginatedValidationWorkflowListList = zod.strictObject({
    count: zod.number().optional(),
    has_next: zod.boolean().optional(),
    has_previous: zod.boolean().optional(),
    limit: zod.number().optional(),
    page: zod.number().optional().describe('The current page number'),
    pages: zod.number().optional().describe('The total number of pages'),
    results: zod
        .array(
            zod.strictObject({
                slug: zod
                    .string()
                    .regex(
                        paginatedValidationWorkflowListListResultsItemSlugRegExp,
                    ),
                name: zod
                    .string()
                    .max(paginatedValidationWorkflowListListResultsItemNameMax),
                form_count: zod.number(),
                created_by: zod.string().nullable(),
                updated_by: zod.string().nullable(),
                created_at: zod.iso.datetime({ offset: true }),
                updated_at: zod.iso.datetime({ offset: true }),
            }),
        )
        .optional(),
});

export type PaginatedValidationWorkflowListList = zod.input<
    typeof PaginatedValidationWorkflowListList
>;
export type PaginatedValidationWorkflowListListOutput = zod.output<
    typeof PaginatedValidationWorkflowListList
>;
